import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Popover } from 'react-tiny-popover';
import IconAngleSmall from '@src/components/Icon/set/IconAngleSmall';

import css from './style.module.scss';

const Sorter = ({ title, sortOrder, onPopoverItemClick, items }) => {
	const [isPopoverOpen, setPopoverOpen] = React.useState(false);

	const handlePopoverItemClick = useCallback(
		(e, item) => {
			e.preventDefault();
			if (onPopoverItemClick) onPopoverItemClick.call(null, item);
			setPopoverOpen(false);
		},
		[onPopoverItemClick, setPopoverOpen],
	);

	const hanleOpenClick = useCallback(
		(e) => {
			e.stopPropagation();
			setPopoverOpen(!isPopoverOpen);
		},
		[isPopoverOpen, setPopoverOpen],
	);

	return (
		<div className={cn(css.block)}>
			<span className={css.title}>{title}</span>
			{sortOrder && (
				<Popover
					isOpen={isPopoverOpen}
					positions={['bottom', 'left', 'right', 'top']}
					align="start"
					padding={10}
					onClickOutside={() => {
						setPopoverOpen(false);
					}}
					content={
						<div className={css.items}>
							{items.map((sortOrderValue) => (
								<a
									className={css.item}
									role="button"
									tabIndex="0"
									onClick={(e) =>
										handlePopoverItemClick(
											e,
											sortOrderValue,
										)
									}
									key={sortOrderValue.label}
								>
									<span>{sortOrderValue.label}</span>
								</a>
							))}
						</div>
					}
				>
					<span
						onClick={hanleOpenClick}
						tabIndex={0}
						role="button"
						className={cn(css.more, {
							[css.more_active]: isPopoverOpen,
						})}
					>
						<span className={css.label}>{sortOrder}</span>
						<IconAngleSmall
							className={cn(
								css.angle,
								css[
									`angle_${isPopoverOpen ? 'top' : 'bottom'}`
								],
							)}
						/>
					</span>
				</Popover>
			)}
		</div>
	);
};

Sorter.propTypes = {
	/**
	 * Заголовок
	 */
	title: PropTypes.string,
	/**
	 * Наименование порядка сортировки
	 */
	sortOrder: PropTypes.string,
	/**
	 * Обработчик клика по элементу поповера. В качестве аргумента принимает Event-объект.
	 */
	onPopoverItemClick: PropTypes.func,
	/**
	 * Массив строк, описывающих содержимое поповера
	 */
	items: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string })),
};

Sorter.defaultProps = {
	title: undefined,
	sortOrder: undefined,
	onPopoverItemClick: undefined,
	items: [],
};

export default Sorter;
